<div class="ubicacion-category-container">
 <loading [isLoading]="hasAppliedFilter && isLoading"></loading>
  
  <div *ngIf="!hasAppliedFilter && !isLoading" class="filter-message">
    <div class="message-content">
      <mat-icon class="filter-icon">filter_list</mat-icon>
      <h3>Selecciona un filtro para mostrar ubicaciones</h3>
      <button mat-raised-button color="primary" (click)="openFilter()" class="filter-button">
        <img [src]="'filtrar_boton.svg' | findUrl" class="filter-icon-img">
        <!-- <mat-icon>tune</mat-icon> -->
        Aplicar Filtro
      </button>
    </div>
  </div>

  <div *ngIf="hasAppliedFilter && locations.length === 0 && !isLoading" class="no-results">
    <div class="message-content">
      <mat-icon class="no-results-icon">search_off</mat-icon>
      <h3>No se encontraron ubicaciones para este filtro</h3>
      <button mat-raised-button color="primary" (click)="openFilter()" class="filter-button">
        <img [src]="'filtrar_boton.svg' | findUrl" class="filter-icon-img">
        <!-- <mat-icon>tune</mat-icon> -->
        Cambiar Filtro
      </button>
    </div>
  </div>

  <div *ngIf="hasAppliedFilter && locations.length > 0" class="filter-applied-bar">
    <span class="results-title">Ubicaciones encontradas para {{selectedFiltersDisplay}}</span>
    <button mat-icon-button (click)="openFilter()" class="selected-filter-button" matTooltip="Cambiar filtro">
      <img [src]="'filtrar_boton.svg' | findUrl" class="filter-icon-img">
      <!-- <mat-icon>tune</mat-icon> -->
    </button>
  </div>
   
    <div class="control-items-wrapper"  *ngIf="hasAppliedFilter && locations.length > 0">
      <div class="control-items" (scroll)="onScroll($event)">
        <div class="itemPanel" *ngFor="let item of locations" (click)="onCardClicked(item)">
            <div class="row itemPanel-flex">
                <div class="item-left">
                    <img class="item-icon" [src]=" (item.panelIcon || selectedCategoryItem.icon) | findUrl">
                </div>
                <div class="row-item item-middle">
                    <div *ngIf="item.statusFlags != null && item.statusFlags.length > 0" class="status-flag-section">
                        <div class="status-flag-set-locations">
                            <mat-icon *ngFor="let flag of item.statusFlags" [matTooltip]="flag.flagName"
                                class="status-flag-icon" [style.color]="flag.priorityHex">{{flag.flagIcon}}</mat-icon>
                        </div>
                    </div>
                    <label class="title-item-act"><strong>{{item.identifier}}</strong></label>
                    <label class="subtitle-item"><strong>{{item.description}}</strong></label>
                </div>
                <div class="item-right" (click)="copyToClipboard(item.identifier); $event.stopPropagation()">
                    <div class="copy-to-clipboard">
                        <img [src]="'boton_copiar_azul.svg' | findUrl">
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="locations.length == 0 && !isLoading">
            <div class="row-item col-12">
                <label class="title-item-des"><strong> No se encontraron resultados</strong></label>
            </div>
        </div>
      </div>
    </div>
</div>


